<template>
  <require from="controls/bs-form-lookup"></require>
  <require from="controls/as-form-widget.html"></require>
  <require from="components/country-experiences-panel"></require>

  <div class="wg-corporate-traveler">
    <as-form-widget heading="Who ${controller.index > 0 ? 'else is' : 'is'} travelling?" icon="fas fa-user-tie">
      <div slot="default">
        <div class="form-row">
          <div class="col-lg-6">
            <bs-form-lookup label.bind="userGroupLabel" placeholder="Find by surname, login or email" item.bind="model.user & validate" options.bind="usersLookupOptions" value-path="name" template-path="templates/user-lookup.html" stick-mode="true" disabled.bind="controller.disabled" tooltip="Type to search for bp employee, then pick the one from the list" maxlength="100"></bs-form-lookup>
          </div>
          <div class="col-lg-6 col-xl-4 offset-xl-2 pl-lg-4 pt-3 pt-lg-0" if.bind="model.countryExperiences.length > 0">
            <country-experiences-panel items.bind="model.countryExperiences & validate" disabled.bind="controller.disabled"></country-experiences-panel>
          </div>
        </div>
      </div>
    </as-form-widget>
  </div>
</template>
